import { getPrimaryRegionIdFromStorage } from '@/helpers'
import {
  enhance,
  withDefaults,
  withTimeout,
  type HttpClient,
  type InitHeaders,
} from '@bldsoft/cappie/transport/http'
import { createFetchHttpClient } from '@bldsoft/cappie/transport/http/fetch'
import { appVersion, env, runtime } from '~/app/environment'
import { model as session } from '~/entities/session'
import { APP_PLATFORM, HEADER, SPECIAL_HEADER } from './index.h'

function guestPrimaryRegionHeader(): string | null {
  const regionId = getPrimaryRegionIdFromStorage()

  // eslint-disable-next-line effector/no-getState
  if (session.$isNotAuthenticated.getState() && regionId) {
    return String(regionId)
  }

  return null
}

const headers: InitHeaders = {
  Accept: 'application/json',
  [HEADER.UVO_PLATFORM]: APP_PLATFORM,
  [HEADER.UVO_APP_NAME]: () => runtime.app.name,
  [HEADER.UVO_DEVICE_TYPE]: () => runtime.device.type.toUpperCase(),
  [HEADER.UVO_DEVICE_OS]: () => runtime.os.name || '',
  [HEADER.UVO_DEVICE_OS_VERSION]: () => runtime.os.version || '',
  [HEADER.UVO_DEVICE_APP_VERSION]: () => appVersion,
  [HEADER.UVO_WEB_METADATA]: () =>
    JSON.stringify({
      browser: runtime.browser.name,
      browserVersion: runtime.browser.version,
    }),
  [SPECIAL_HEADER.CLIENT_PRIMARY_REGION]: guestPrimaryRegionHeader,
}

export function createOvpHttpClient(): HttpClient {
  return enhance(
    createFetchHttpClient(),
    withDefaults({
      headers,
    }),
    withTimeout(env.UVO_CLIENT_HTTP_TIMEOUT)
  )
}
